import { InMemoryCache, Reference, makeVar } from "@apollo/client";

export const isLoggedInVar = makeVar<boolean>(false);

// Initializes to an empty array
export const cartItemsVar = makeVar<string[]>([]);
